import React, { Component } from "react";
import { translate } from "../../../utils/useful";
import FormViewer from "../../FormViewer";
import ExistingForms from "./ExistingForms";

class FormInputConfig extends Component {
    state = {
    };

    init = () => {

    }

    liveChange = (data, init, key, value, extra) => {
        if (!init) {
            this.props.updateInputData(key, value)
        }
    }

    validateForm = (cb) => {
        let data = this.form.getForm()
        if (data) {
            cb(true)
        } else {
            cb(false)
        }
    }


    render() {


        return (
            <div className="w-100 h-100 bg-white scroll-no-scrollbar pt-3 pb-3">
                <div className="px-3 w-100">
                    <div className=" mb-2 pb-2" style={{ borderBottom: '1px solid #f2f6f8' }}>
                        <div className="flexc">
                            <img src={this.props.input?.icon} height={20} />
                            <p className="mld-2 text-normal text-semibold">{translate(this.props.input?.label)}</p>
                        </div>
                        <p className="text-smaller  ">Configuration</p>
                    </div>
                </div>


                <FormViewer ref={el => this.form = el} liveChange={this.liveChange} headers={this.props.headers} initData={this.props.initData} errors={this.state.errors} formClass="modern" inputClass={'modern-input'} variables={this.props.variables} />


            </div>
        );
    }
}

export default FormInputConfig;
